import { render } from "./PlaceModal.vue?vue&type=template&id=5e24e515&scoped=true&ts=true"
import script from "./PlaceModal.vue?vue&type=script&lang=ts"
export * from "./PlaceModal.vue?vue&type=script&lang=ts"

import "./PlaceModal.vue?vue&type=style&index=0&id=5e24e515&scoped=true&lang=css"

import exportComponent from "/home/bese/Documents/partybeast/party-beast-prototype/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e24e515"]])

export default __exports__